import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#FDFDFB] flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        <Link to="/" className="inline-flex items-center gap-2 mb-8">
          <Logo />
        </Link>
        <XCircle className="w-10 h-10 mx-auto text-[#5C6661]" />
        <h1 className="font-display text-3xl font-bold tracking-tight mt-6">Checkout cancelled</h1>
        <p className="text-sm text-[#5C6661] mt-2">No worries — nothing was charged. You can upgrade whenever you&apos;re ready.</p>
        <div className="mt-6 flex justify-center gap-3">
          <Link to="/pricing"><Button className="rounded-full bg-[#2D4A3E] hover:bg-[#3B5F50]" data-testid="try-again-btn">Try again</Button></Link>
          <Link to="/app"><Button variant="outline" className="rounded-full border-[#E2E8E4]">Back to app</Button></Link>
        </div>
      </div>
    </div>
  );
}
